import { RobotForm } from '@/components/form/RobotForm'
import type { RobotFormValues } from '@/components/form/RobotForm'
import { Button } from '@/components/ui/button'
import type { Form } from 'antd'
import { FLAT_FORM_CLASS } from '../constants'

interface RobotConfigTabProps {
  form: ReturnType<typeof Form.useForm<RobotFormValues>>[0]
  initialValues?: Partial<RobotFormValues>
  isUpdating: boolean
  onWorkingScheduleRemove: (row: any) => void
  onValuesChange: (changedValues: any, allValues: any) => void
  onSubmit: (values: RobotFormValues) => void
}

export function RobotConfigTab({
  form,
  initialValues,
  isUpdating,
  onWorkingScheduleRemove,
  onValuesChange,
  onSubmit,
}: RobotConfigTabProps) {
  return (
    <div className="flex flex-col">
      <div className={`px-6 pt-3 ${FLAT_FORM_CLASS}`}>
        <RobotForm
          mode="update"
          form={form}
          hideActions
          initialValues={initialValues}
          onWorkingScheduleAdd={() => {}}
          onWorkingScheduleRemove={onWorkingScheduleRemove}
          onValuesChange={onValuesChange}
          onSubmit={onSubmit}
          onCancel={() => window.history.back()}
        />
      </div>

      <div className="flex justify-end gap-3 border-t border-gray-100 px-6 py-4 mt-4">
        <Button
          variant="outline"
          size="md"
          className="min-w-[120px] h-10 rounded-full border-slate-300 text-slate-700"
          onClick={() => window.history.back()}
        >
          Hủy
        </Button>
        <Button
          variant="primary"
          size="md"
          className="min-w-[120px] h-10 rounded-full bg-amber-600 hover:bg-amber-700 text-white"
          loading={isUpdating}
          onClick={() => form.submit()}
        >
          Lưu
        </Button>
      </div>
    </div>
  )
}
